import { RouteObject, useRoutes } from "react-router-dom";

import ErrorBoundaryLayout from "@/layouts/error-boundary";
import NotFoundPage from "./not-found";

const configErrorRoutes: RouteObject[] = [
  {
    path: "*",
    element: <ErrorBoundaryLayout />,
    children: [
      {
        index: true,
        element: <NotFoundPage />,
      },
    ],
  },
];

function ErrorBoundaryPage() {
  return useRoutes(configErrorRoutes);
}

export default ErrorBoundaryPage;
